import { render } from "./ConnectEmrModal.vue?vue&type=template&id=032f0c6c&scoped=true"
import script from "./ConnectEmrModal.vue?vue&type=script&lang=js"
export * from "./ConnectEmrModal.vue?vue&type=script&lang=js"

import "./ConnectEmrModal.vue?vue&type=style&index=0&id=032f0c6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-032f0c6c"]])

export default __exports__